/** @jsxImportSource solid-js */

import { customElement, noShadowDOM } from "solid-element";
import { globalState } from "#root/frontend/state";
import { WarningCallout } from "#root/lib/palette/components/callout.solid";

export function PersonalEmailNeeded() {
  return (
    <WarningCallout title="Your account is using a campus email for recovery">
      <p>
        <a
          class="underline"
          onClick={() => {
            globalState.setShouldShowRecoveryUpdateModal(true);
          }}
        >
          Click here
        </a>{" "}
        to change this, otherwise if you lose access to your campus email, you
        will not be able to reset your password.
      </p>
    </WarningCallout>
  );
}

customElement("recovery-personal-email-needed", {}, () => {
  noShadowDOM();

  return <PersonalEmailNeeded />;
});
